import LandingSection from "../components/LandingSection";
import React from "react";

const LandingPage = () => {
    return <div className={'landing-page'}>
        <LandingSection/>
    </div>
}

export default LandingPage;